export function isLastChar(index: number, input: string): boolean {
  return index === input.length - 1;
}
